import * as actionTypes from './actionTypes';

export const setInFlightCasesStateForEntity = (entityId, inFlightState) => ({
  type: actionTypes.SET_INFLIGHT_CASES_STATE_FOR_ENTITY,
  entityId,
  inFlightState
})

export const clearInFlightCasesStateForAllEntites = () => ({
  type:  actionTypes.CLEAR_INFLIGHT_CASES_STATE_FOR_ALL_ENTITIES
})



// WEBPACK FOOTER //
// ./src/components/ViewEntityProfile/actions/actionCreator.js